import { schema as schemas } from 'normalizr'
import { CallApi } from '@signavio/kraken'

import { Form } from '../../../types'
import { Nullable } from '@signavio/effektif-commons'
import qs from 'qs'

export const collection = 'startInfo'

export const schema = new schemas.Entity(
  collection,
  {},
  {
    idAttribute: (startInfo: { form: Form }) => {
      if (startInfo.form == null || startInfo.form.fields.length === 0) {
        return '0'
      }

      return startInfo.form.fields.map((field) => field.id).join('-')
    },
  }
)

export const fetch =
  (callApi: CallApi, apiBase: string) =>
  ({ id, caseId }: { id: string; caseId: Nullable<string> }) => {
    const query = caseId
      ? qs.stringify({ caseId }, { addQueryPrefix: true })
      : ''

    return callApi(`${apiBase}/workflows/${id}/startInfo${query}`, schema)
  }

export const update =
  (callApi: CallApi, apiBase: string) =>
  ({ id }: { id: string }, body: object) =>
    callApi(`${apiBase}/workflows/${id}/startInfo`, schema, {
      method: 'PUT',
      body,
    })
